/**
 * Saved-links paging. The Links page used to load page 1 only (the 35 newest rows), so every older saved link looked "missing".
 * Pure helpers, so the behaviour is testable without rendering the gallery.
 */
export const hasMorePages = (page, lastPage) => Number(page) < Number(lastPage || 1);

/** append the next page, never twice (a refetch racing a scroll can deliver the same row again) */
export const mergePages = (existing = [], incoming = []) => {
  const seen = new Set(existing.map((r) => r.id));
  return [...existing, ...incoming.filter((r) => !seen.has(r.id))];
};

/**
 * Walks the pager the way the scroll sentinel does: load page 1, then page+1 while there is more.
 * `fetchPage(n)` -> { data, pagination: { total_pages } }. Returns every row reachable.
 */
export const loadAllPages = async (fetchPage, maxPages = 200) => {
  let rows = [];
  let page = 1;
  let last = 1;
  do {
    const res = await fetchPage(page);
    rows = mergePages(rows, res?.data ?? []);
    last = res?.pagination?.total_pages ?? 1;
    page += 1;
  } while (hasMorePages(page - 1, last) && page <= maxPages);
  return rows;
};
